import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Modal,
  notification,
  Row,
  Select,
  Spin,
  Table,
} from "antd";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { getManagingOffice, getResourceData, getTempEngagementFormData, getUserInfo, getUserList } from "redux/selectors";
import { Required } from "./index.js";
import { useScrollFetch } from "hooks/useScrollFetch.js";
import queryKeys from "common/queryKey.js";
import { useClientsListSource, getClientsListPageData } from "hooks/useClientsListSource";
import { ButtonFilled } from "reusableComponent/UIButtons/index.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import { useFetch } from "hooks/useFetch.js";
import { useScrollFetch2 } from "hooks/useScrollFetch2.js";
import { CALL_API, CALL_FEATCH_API } from "common/API.js";
import { MAIN_CLIENT_ID } from "common/Constants.js"; // NOTE: update this path if MAIN_CLIENT_ID lives elsewhere in your project
import circleWarning from "../../../assets/icons/Circle_Warning.svg";

const labelStyle = {
  width: "150px",
  display: "inline-block",
  textAlign: "start",
};

export const enableIfActiveAndStakeHolder = (disabled, engagementData, userInfo, update, engagementHigherUsers) => {
  if (disabled) {
    const engagementStatus = engagementData?.jobCloser?.status;
    const isPartnerOrManagerOrHeadOfficeUser =
      userInfo?.userid === engagementData?.stakeHolder?.personIncharge ||
      userInfo?.userid === engagementData?.stakeHolder?.partner ||
      userInfo?.userid === engagementHigherUsers?.includes(userInfo?.userid) || userInfo?.roleId === "8";
    const isEngagementActive = engagementStatus === "Active" || userInfo?.roleId === "8";

    return update ? !(isPartnerOrManagerOrHeadOfficeUser && isEngagementActive) : false;
  }
  return false;
};

const StakeHolderFields = ({ noEditAccess = false, update, engagementData, disabled, isPersonInchargeChanged, isPersonInchargeChangedPath, submitEngagement }) => {

  const form = Form.useFormInstance();
  const history = useHistory();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);
  const [partnerApiLoading, setPartnerApiLoading] = useState(false);
  const [personInchargeEngagementData, setPersonInchargeEngagementData] = useState([]);

  const userList = useSelector((state) => getUserList(state));
  const activeUserslist = userList.filter((item) => item.statusid === "1");
  const userInfo = useSelector(getUserInfo);
  const tempEngagementFormData = useSelector((state) =>
    getTempEngagementFormData(state)
  );

  const userListOptions = userList
    .filter(
      (user) =>
        user?.designation === "Managing Partner" ||
        user?.designation === "Partner" ||
        user?.designation === "Senior Partner"
    )
    .map((user) => ({
      label: user.fullname,
      value: user.userid,
    }));

  const allUserListOptions = activeUserslist.map((user) => {
    return {
      label: user.fullname,
      value: user.userid,
    };
  });
  const selectedPartner = form.getFieldValue("partner");

  const queryParams = new URLSearchParams();
  queryParams.append("engagementid", engagementData?.engagementId);
  queryParams.append("managingOffice", engagementData?.client?.managingOffice);

  const queryString = queryParams.toString();

  const { getResourcePlanDataById } = queryKeys;

  const { key: resourceplanemployeelistkey, url: resourceplanemployeelisturl } =
    getResourcePlanDataById(engagementData?.engagementId, `?${queryString}`);

  const { data: resourceplanemployeelistres, refetch } = useScrollFetch2(
    resourceplanemployeelistkey,
    {
      endPoint: resourceplanemployeelisturl,
      queryParam: "lastEvaluatedKey",
    }
  );

  const dataList = useMemo(() => {
    return resourceplanemployeelistres?.pages?.reduce((acc, page) => {
      if (page?.response?.data === undefined) return acc;
      return [...acc, ...page?.response?.data];
    }, []);
  }, [resourceplanemployeelistres]);

  useEffect(() => {
    refetch();
  }, [engagementData?.engagementId])

  const partnerCountry = activeUserslist?.find(
    (user) => user.userid === userInfo?.userid
  )?.managingoffice[0];

  const partnerGrade = ["P1", "P2", "P3", "P4", "P5"];

  const managerGrade = ["M1", "M2"];

  let filteredPartnerPersonInChargeUserList =
    (engagementData?.employeeList?.length > 0 || tempEngagementFormData?.resourceList?.length > 0)
      ? activeUserslist?.filter(item =>
        !(
          (engagementData?.employeeList?.some(emp => emp.userId === item?.userid && emp.projectRole === "Member" && dataList?.some(resource => resource?.userId === item?.userId && resource?.status !== "Un Assigned"))) ||
          (tempEngagementFormData?.resourceList?.some(emp => emp.userId === item?.userid && emp.projectRole === "Member"))
        )
      )
      : activeUserslist;

  const loggedInUser = activeUserslist?.find(
    (user) => user.userid === userInfo?.userid
  );

  const partnerOptions = filteredPartnerPersonInChargeUserList
    ?.filter((user) => {
      if (disabled) {
        return user;
      }

      const engagementManagingOffice = form.getFieldValue("managing_office");

      // Check if user's primary managing office matches engagement office
      const isPrimaryOfficeMatch = user.managingoffice.includes(engagementManagingOffice);

      // Check if user has subcluster enabled and engagement office is in their subcluster countries
      const isSubclusterMatch =
        user.subcluster === true &&
        user.subclustercountries &&
        user.subclustercountries.includes(engagementManagingOffice);

      const isGradeMatch = partnerGrade.some((grade) => grade === user.grade);

      return (isPrimaryOfficeMatch || isSubclusterMatch) && isGradeMatch;
    })
    .map((partner) => ({
      label: partner.fullname,
      value: partner.userid,
    }));

  const managerUserOptions = filteredPartnerPersonInChargeUserList
    ?.filter((partner) => {
      const engagementManagingOffice = form.getFieldValue("managing_office");
      if (!engagementManagingOffice) {
        return false;
      }

      // const allowedGrades = [                      // Future use
      //   "S1", "S2", "S3", "S4", "S5", "S6", "S7",
      //   "C1", "C2", "C3", "C4",
      //   "M1", "M2", "M3",
      //   "D1", "D2",
      //   "P1", "P2", "P3", "P4", "P5"
      // ];

      // const isValidGrade = allowedGrades.includes(partner.grade);

      // if (!isValidGrade) {
      //   return false;
      // }

      // ✅ Check if primary managing office matches
      const isPrimaryOfficeMatch =
        partner.managingoffice &&
        Array.isArray(partner.managingoffice) &&
        partner.managingoffice.includes(engagementManagingOffice);

      // ✅ Check if user has subcluster enabled AND engagement office is in their subcluster countries
      const isSubclusterMatch =
        partner.subcluster === true &&
        partner.subclustercountries &&
        Array.isArray(partner.subclustercountries) &&
        partner.subclustercountries.includes(engagementManagingOffice);

      const MANAGER_ROLE_IDS = ["5", "4"];
      const isManager =
        Array.isArray(partner.roleid) &&
        partner.roleid.some((id) => MANAGER_ROLE_IDS.includes(id));

      // ✅ User must match office (primary OR subcluster) AND have manager role/grade
      const officeMatch = isPrimaryOfficeMatch || isSubclusterMatch;

      return officeMatch && isManager;
    })
    .map((partner) => ({
      label: partner.fullname,
      value: partner.userid,
    }));

  // Person Incharge dropdown: when the LOGGED-IN user's record in userList
  // belongs to the main client, keep the filtered manager-grade/
  // office-matched list; otherwise show all active users.
  // NOTE: confirm the actual field name on the userList record that holds
  // the client id (guessed as `clientid` below — update if it's e.g.
  // `clientId` / `client_id`).
  const personInchargeOptions =
    loggedInUser?.clientid === MAIN_CLIENT_ID
      ? managerUserOptions
      : allUserListOptions;

  const countryBasedUserOptions = activeUserslist
    ?.filter(
      (partner) =>
        partner.managingoffice[0] === form.getFieldValue("managing_office") &&
        ![...managerGrade, ...partnerGrade].includes(partner?.grade)
    )
    .map((partner) => ({
      label: partner.fullname,
      value: partner.userid,
    }));

  const relationshipPartnerOptions = userListOptions.filter(
    (partner) => partner?.value !== selectedPartner
  );

  const manageoffice = useSelector((state) => getManagingOffice(state));
  const managinOfficeOptions = manageoffice.map((value) => {
    return {
      label: value,
      value: value,
    };
  });

  const { key, url } = useClientsListSource();

  const {
    data: clientsDataRes,
    fetchNextPage,
    isLoading: loading,
    hasNextPage,
  } = useScrollFetch(key, {
    endPoint: url,
    queryParam: "LastEvaluatedKey",
  });

  const clients = useMemo(() => {
    return clientsDataRes?.pages?.reduce((acc, page) => {
      const pageData = getClientsListPageData(page);
      if (pageData === undefined) return acc;
      return [...acc, ...pageData];
    }, []);
  }, [clientsDataRes]);

  const clientOptions = clients
    ?.filter(
      (client) =>
        client?.bdo_id !== "NULL" && client?.bdo_strategicpartner === false
    )
    ?.map((client) => ({
      label: client?.registeredName,
      value: client?.clientId,
    }));

  const onScroll = async (event) => {
    const target = event.target;
    if (
      !loading &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      console.log("Loading...");
      target.scrollTo(0, target.scrollHeight);
      hasNextPage && fetchNextPage();
    }
  };

  const planEndDateDisable = enableIfActiveAndStakeHolder(disabled, engagementData, userInfo, update)
  const planStartDateDisable = enableIfActiveAndStakeHolder(disabled, engagementData, userInfo, update)
  const partnerDisable = enableIfActiveAndStakeHolder(disabled, engagementData, userInfo, update)
  const personInchargeDisable = enableIfActiveAndStakeHolder(disabled, engagementData, userInfo, update)

  const engagementStatus = engagementData?.jobCloser?.status;
  // TODO: conditionally disable the fields based on the status of the engagement

  // Pending-reassignment popups should read the new partner/person in
  // charge's name, not their raw email id.
  const getDisplayName = (email) => {
    if (!email) return "N/A";
    const user = userList?.find((u) => u.userid === email);
    return user?.fullname || email;
  };

  const pendingBillingColumns = [
    { title: "Billing ID", dataIndex: "billingid", key: "billingid" },
    { title: "Billing Name", dataIndex: "description", key: "description" },
    { title: "Amount", dataIndex: "amount", key: "amount" },
    { title: "Status", dataIndex: "statusname", key: "statusname" },
  ];

  const handlePartnerChange = async (value) => {
    const oldPartner = selectedPartner;
    if (
      !update ||
      !oldPartner ||
      value === oldPartner ||
      !engagementData?.engagementId
    ) {
      form.setFieldValue("partner", value);
      return;
    }
    setPartnerApiLoading(true);
    try {
      const billingRes = await CALL_API(
        `insyts/billing?engagementid=${engagementData?.engagementId}`,
        "get"
      );
      const pendingBillingItems = (billingRes?.items || []).filter(
        (bill) => bill?.statusname === "Pending"
      );
      if (pendingBillingItems.length > 0) {
        Modal.confirm({
          className: "pending-reassign-confirm-modal",
          icon: (
            <div style={{ width: "100%", textAlign: "center" }}>
              <img src={circleWarning} alt="Warning" />
            </div>
          ),
          width: 700,
          content: (
            <div>
              <p>
                This engagement has pending billing under the current
                partner. Proceeding will update the billing records and the
                engagement&apos;s partner to <b>{getDisplayName(value)}</b>.
              </p>
              <Table
                columns={pendingBillingColumns}
                dataSource={pendingBillingItems}
                rowKey="billingid"
                pagination={false}
                bordered
                size="small"
              />
              <p style={{ marginTop: 12 }}>Would you like to proceed?</p>
            </div>
          ),
          okText: "Proceed & Save",
          cancelText: "Cancel",
          onOk: async () => {
            // Mandatory fields must be filled before touching anything -
            // check this first so a failing engagement save never leaves the
            // reassignment already done with nothing to show for it.
            try {
              await form.validateFields();
            } catch (validationError) {
              notification.error({ message: "Please fill the mandatory fields" });
              form.setFieldValue("partner", oldPartner);
              return;
            }
            // Reassignment must succeed before the partner change (and the
            // engagement update that follows) is allowed to go through - on
            // failure, show the error and leave the engagement untouched.
            try {
              await CALL_API(
                `insyts/billing?engagementid=${engagementData?.engagementId}&action=reassign-partner`,
                "patch",
                { newPartner: value }
              );
            } catch (error) {
              console.error(
                "[handlePartnerChange] reassign billing partner error -->",
                error
              );
              notification.error({
                message:
                  "Failed to reassign pending billing to the new partner. The engagement partner was not changed.",
              });
              form.setFieldValue("partner", oldPartner);
              return;
            }
            notification.success({
              message: "Pending billing reassigned to the new partner.",
              duration: 2,
            });
            form.setFieldValue("partner", value);
            // Persist the new partner on the engagement itself right away,
            // rather than waiting for the page's own Save button. If the
            // engagement itself fails validation (mandatory fields missing
            // elsewhere on the form), don't leave the partner change
            // standing - submitEngagement already showed the error.
            if (submitEngagement) {
              const saved = await submitEngagement();
              if (!saved) {
                form.setFieldValue("partner", oldPartner);
              }
            }
          },
          onCancel: () => {
            form.setFieldValue("partner", oldPartner);
          },
        });
        return;
      }
    } catch (error) {
      console.error(
        "[handlePartnerChange] pending billing check error -->",
        error
      );
    } finally {
      setPartnerApiLoading(false);
    }
    form.setFieldValue("partner", value);
  };

  const personIncharge = form.getFieldValue("person_incharge");
  // Commented out per request: this used to check whether the newly selected
  // person in charge already manages other engagements, via
  // insyts/timesheet/engagementpersonincharge, and show them in a separate
  // informational modal before committing the change. The pending-timesheet
  // check (insyts/timesheet/pendingtimesheetbyengagement) in
  // handlePersonInChargeChange below is now the only check used — same
  // popup+confirm pattern as the partner flow — so this just commits the
  // value directly.
  const proceedWithPersonInchargeCapacityCheck = async (value) => {
    // if (isPersonInchargeChanged === undefined) {
    //   setApiLoading(true);
    //   try {
    //     const apiResponse = await CALL_FEATCH_API(
    //       `insyts/timesheet/engagementpersonincharge?officesupervisorId=${personIncharge}`,
    //       "get"
    //     );
    //     const data = apiResponse?.response?.data ?? [];
    //     const code = apiResponse?.response?.code?.toLowerCase();
    //     if (code === "success" && Array.isArray(data)) {
    //       setPersonInchargeEngagementData(data);
    //       if (data?.length > 0) {
    //         setIsModalVisible(true);
    //       } else {
    //         form.setFieldValue("person_incharge", value);
    //         notification.success({
    //           message: "Person Incharge changed successfully",
    //           duration: 2,
    //         });
    //       }
    //     } else {
    //       notification.error({
    //         message: "API Error",
    //         description: "Unexpected response format.",
    //       });
    //     }
    //   } catch (error) {
    //     console.error("Error fetching engagement details:", error);
    //     notification.error({
    //       message: "Fetch failed",
    //       description: error?.message || "Something went wrong.",
    //     });
    //   } finally {
    //     setApiLoading(false);
    //   }
    // }
    form.setFieldValue("person_incharge", value);
  };

  const pendingTimesheetColumns = [
    { title: "Employee Name", dataIndex: "employeeName", key: "employeeName" },
    { title: "Week", dataIndex: "week", key: "week" },
    {
      title: "Hours",
      key: "hours",
      render: (_, record) =>
        (record.entries || []).reduce(
          (acc, entry) => acc + (entry.sum || 0),
          0
        ),
    },
    { title: "Status", key: "status", render: () => "Pending" },
  ];

  const handlePersonInChargeChange = async (value) => {
    if (isPersonInchargeChangedPath === "/add-engagement") {
      form.setFieldValue("person_incharge", value);
      return;
    }

    const oldPersonIncharge = personIncharge;
    if (
      update &&
      oldPersonIncharge &&
      value !== oldPersonIncharge &&
      engagementData?.engagementId
    ) {
      // Pass the engagement's own resourceList so the backend can query the
      // employeeId-week-index GSI per employee (same technique as
      // insyts/timesheet/unapproved) instead of scanning every timesheet
      // record for the whole client — cuts the check from ~20s to near-instant.
      // The timesheet table's "employeeId" attribute is actually the user's
      // email (set from userInfo.userid at submission time), so this must
      // use userId, not employeeId — matches JobCloserFields.js's
      // fetchUnapprovedTimesheets, which hits the same GSI.
      const resourceList = [
        ...new Set(
          (engagementData?.employeeList || [])
            .map((emp) => emp?.userId)
            .filter((id) => id !== null && id !== undefined && id !== "")
        ),
      ];
      setApiLoading(true);
      try {
        const timesheetRes = await CALL_API(
          `insyts/timesheet/pendingtimesheetbyengagement`,
          "post",
          {
            engagementId: engagementData?.engagementId,
            personIncharge: oldPersonIncharge,
            resourceList,
          }
        );
        const pendingTimesheetItems = timesheetRes?.pendingTimesheet || [];
        if (pendingTimesheetItems.length > 0) {
          Modal.confirm({
            className: "pending-reassign-confirm-modal",
            icon: (
              <div style={{ width: "100%", textAlign: "center" }}>
                <img src={circleWarning} alt="Warning" />
              </div>
            ),
            width: 700,
            content: (
              <div>
                <p>
                  This engagement has pending chargeable timesheet entries
                  under the current person in charge. Proceeding will update
                  those entries and the engagement&apos;s person in charge to{" "}
                  <b>{getDisplayName(value)}</b>.
                </p>
                <Table
                  columns={pendingTimesheetColumns}
                  dataSource={pendingTimesheetItems}
                  rowKey="timeSheetId"
                  pagination={false}
                  bordered
                  size="small"
                />
                <p style={{ marginTop: 12 }}>Would you like to proceed?</p>
              </div>
            ),
            okText: "Proceed & Save",
            cancelText: "Cancel",
            onOk: async () => {
              // Mandatory fields must be filled before touching anything -
              // check this first so a failing engagement save never leaves
              // the reassignment already done with nothing to show for it.
              try {
                await form.validateFields();
              } catch (validationError) {
                notification.error({ message: "Please fill the mandatory fields" });
                form.setFieldValue("person_incharge", oldPersonIncharge);
                return;
              }
              // Reassignment must succeed before the person-in-charge change
              // (and the engagement update that follows) is allowed to go
              // through - on failure, show the error and leave the
              // engagement untouched.
              try {
                await CALL_API(`insyts/timesheet/reassignpersonincharge`, "patch", {
                  engagementId: engagementData?.engagementId,
                  oldPersonIncharge,
                  newPersonIncharge: value,
                  resourceList,
                });
              } catch (error) {
                console.error(
                  "[handlePersonInChargeChange] reassign timesheet error -->",
                  error
                );
                notification.error({
                  message:
                    "Failed to reassign pending timesheet entries to the new person in charge. The engagement person in charge was not changed.",
                });
                form.setFieldValue("person_incharge", oldPersonIncharge);
                return;
              }
              notification.success({
                message:
                  "Pending timesheet entries reassigned to the new person in charge.",
                duration: 2,
              });
              await proceedWithPersonInchargeCapacityCheck(value);
              // Persist the new person in charge on the engagement itself
              // right away, rather than waiting for the page's own Save
              // button. If the engagement itself fails validation (mandatory
              // fields missing elsewhere on the form), don't leave the
              // person-in-charge change standing - submitEngagement already
              // showed the error.
              if (submitEngagement) {
                const saved = await submitEngagement();
                if (!saved) {
                  form.setFieldValue("person_incharge", oldPersonIncharge);
                }
              }
            },
            onCancel: () => {
              form.setFieldValue("person_incharge", oldPersonIncharge);
            },
          });
          return;
        }
      } catch (error) {
        console.error(
          "[handlePersonInChargeChange] pending timesheet check error -->",
          error
        );
      } finally {
        setApiLoading(false);
      }
    }

    await proceedWithPersonInchargeCapacityCheck(value);
  };

  const columns = [
    {
      title: "Engagement ID",
      dataIndex: "engagementId",
      key: "engagementId",
    },
    {
      title: "Job Title",
      dataIndex: ["information", "jobTitle"],
      key: "jobTitle",
    },
    {
      title: "Client Name",
      dataIndex: ["client", "clientName"],
      key: "clientName",
    },
    {
      title: "Managing Office",
      dataIndex: ["client", "managingOffice"],
      key: "managingOffice",
    },
    {
      title: "Partner",
      dataIndex: ["stakeHolder", "partner"],
      key: "partner",
    },
    {
      title: "Person Incharge",
      dataIndex: ["stakeHolder", "personIncharge"],
      key: "personIncharge",
    }
  ];

  return (
    <>
      {isModalVisible && personInchargeEngagementData?.length > 0 && (
        <Modal
          title="Engagement Details"
          open={isModalVisible}
          onOk={() => {
            setIsModalVisible(false);
            notification.success({
              message: "Person Incharge changed successfully",
              duration: 2,
            });
          }}
          onCancel={() => setIsModalVisible(false)}
          width={1000}
          okText="Confirm"
        >
          <Table
            columns={columns}
            dataSource={personInchargeEngagementData}
            rowKey="engagementId"
            pagination={false}
            bordered
          />
        </Modal>
      )}
      <Card className="fields-card">
        <Row gutter={24}>
          <Col span={12}>
            <Spin spinning={partnerApiLoading}>
              <Form.Item
                label={
                  <span style={labelStyle}>
                    Partner <Required />
                  </span>
                }
                name="partner"
                rules={[
                  {
                    required: true,
                    message: "Please enter Partner!",
                  },
                ]}
              >
                <Select
                  placeholder="Select"
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input.toLowerCase()
                    )
                  }
                  showSearch={true}
                  options={partnerOptions}
                  disabled={noEditAccess || (partnerDisable)}
                  onChange={handlePartnerChange}
                />
              </Form.Item>
            </Spin>
            <Form.Item
              label={<span style={labelStyle}>QA Partner</span>}
              name="relationship_partner"
              rules={[
                {
                  required: false,
                  message: "Please enter QA Partner!",
                },
              ]}
            >
              <Select
                placeholder="Select"
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  )
                }
                showSearch={true}
                options={partnerOptions}
                disabled={noEditAccess || (userInfo?.roleId === "2" ? false : partnerDisable)}
                allowClear={true}
              />
            </Form.Item>
            <Spin spinning={apiLoading}>
              <Form.Item
                label={
                  <span style={labelStyle}>
                    Person Incharge <Required />
                  </span>
                }
                name="person_incharge"
                rules={[
                  {
                    required: true,
                    message: "Please enter Person Incharge!",
                  },
                ]}
              >
                <Select
                  placeholder="Select"
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input.toLowerCase()
                    )
                  }
                  options={personInchargeOptions}
                  disabled={noEditAccess || (personInchargeDisable)}
                  onChange={handlePersonInChargeChange}
                />
              </Form.Item>
            </Spin>
            <Form.Item
              label={<span style={labelStyle}>IS Auditor</span>}
              name="isauditor"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please enter Person Incharge!",
            //   },
            // ]}
            >
              <Select
                placeholder="Select"
                // options={countryBasedUserOptions}
                allowClear={true}
                options={managerUserOptions}
                showSearch={true}
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  )
                }
                disabled={noEditAccess || (userInfo?.roleId === "2" ? false : personInchargeDisable)}
              />
            </Form.Item>
            <Form.Item
              label={<span style={labelStyle}>Referring BDO Firm</span>}
              name="referring_bdo_firm"
            >
              <Select
                placeholder="Select"
                options={clientOptions?.filter((item) =>
                  item?.label?.includes("BDO")
                )}
                onPopupScroll={onScroll}
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                allowClear={true}
                disabled={noEditAccess || (disabled)}
              />
            </Form.Item>
            <Form.Item
              label={<span style={labelStyle}>Other side Entity Name</span>}
              name="other_side_entity_name"
            >
              <Select
                allowClear={true}
                id="client"
                placeholder="Select"
                options={clientOptions}
                onPopupScroll={onScroll}
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                disabled={noEditAccess || (disabled)}
              />
            </Form.Item>

            {/* <Form.Item name="sent_to_referaal" valuePropName="checked">
            <Checkbox>Deliverable to be sent to referral</Checkbox>
          </Form.Item> */}
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span style={labelStyle}>
                  Plan Start Date <Required />
                </span>
              }
              name="plan_start_date"
              rules={[
                {
                  required: true,
                  message: "Please enter Plan Start Date!",
                },
              ]}
            >
              <DatePicker
                placeholder="Select"
                format="DD-MM-YYYY"
                // disabledDate={(current) => {
                // return current.isBefore(moment(), 'day'); // Disable all dates before today
                // }}
                disabled={noEditAccess || (planStartDateDisable)}
              />
            </Form.Item>
            <Form.Item
              label={
                <span style={labelStyle}>
                  Plan End Date <Required />
                </span>
              }
              name="plan_end_date"
              rules={[
                {
                  required: true,
                  message: "Please enter Plan End Date!",
                },
              ]}
            >
              <DatePicker
                placeholder="Select"
                format="DD-MM-YYYY"
                // disable the past days from Plan Start Date
                disabledDate={(current) => {
                  const planStartDate = form.getFieldValue("plan_start_date");
                  return current && current < moment(planStartDate);
                }}
                disabled={noEditAccess || (planEndDateDisable)}
              />
            </Form.Item>
            {!update && (
              <div className="d-flex">
                <span style={labelStyle}></span>
                <Button
                  className="ms-3"
                  type="primary"
                  onClick={() => {
                    history.push("/engagementCalendar");
                  }}
                  disabled={false} // navigation - stays usable in a read-only form
                >
                  Look Up
                </Button>
              </div>
            )}

            {/* <Form.Item
            label={<span style={labelStyle}>Client FY Start</span>}
            name="client_fy_start"
          >
            <DatePicker placeholder="Select" />
          </Form.Item>
          <Form.Item
            label={<span style={labelStyle}>Client FY End</span>}
            name="client_fy_end"
          >
            <DatePicker
              placeholder="Select"
              disabledDate={(current) => {
                const clientFyStart = form.getFieldValue("client_fy_start");
                return current && current < moment(clientFyStart);
              }}
            />
          </Form.Item> */}

            {/* <div class="text-center">
            <Button>Sub Engagement</Button>
          </div> */}
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default StakeHolderFields;